import React, { useEffect, useState, useContext } from "react";
import "../../styles/Broadcast.css";

import CampaignHeader from "../campaigns/CampaignHeader";
import SettingBroad from "./SettingBroad";

import { BroadSettingList } from "../../../../constant/app/campaign/Broadcast";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ICONS } from "../../../../assets/icons";
// import { Button } from "../../../../components/form/Button/Button";
import {
  updateGlobalLoader,
  updateToggleToast,
} from "../../../../reduxToolkit/appSlice";
import {
  useAspDispatch,
  useAspSelector,
} from "../../../../test/jest-redux-hooks";
import {
  broadCastCreateApi,
  broadcastSingleApi,
  createActivateApi,
  draftApi,
  templateList,
} from "../../api/Api";
import BroadcastMessage from "./BroadcastMessage";
import BroadcastReview from "./BroadcastReview";
import BroadcastSegments from "./BroadcastSegments";
import Define_Audience from "./Define_Audience";

import moment from "moment";
import { setDateCombine } from "../../../../reduxToolkit/CampaignSlice";
import {
  clearIndividualErrors,
  setCallEnabled,
  setDelayValue,
  setDelayValue1,
  setIndividualError,
  setSaveBroadcastDatas,
  setSelectedTime1,
  setUpdatedInputValue,
} from "../../../../reduxToolkit/broadcastSlice";
import { whatsappBusinessNumbers } from "../../../channels/api/Api";
import BroadcastMessageView from "./BroadcastView/BroadcastMessageView";
import { getProducts } from "../../../products/api/api";

import Loader from "../../../../components/commonComponents/Loader/Index";
import {
  formatTimeWithAmPm,
  getTimeString,
} from "../../../../helper/timeUtils";
import useToggle from "../../../../hooks/useToggle";
import { showErrorToast } from "../../../../components/commonComponents/gxAntdToast/toastUtils";
import NotificationContext from "../../../../providers/NotificationProvider";
import { Button, ConfigProvider, Typography } from "antd";

// UTC conversion utilities
const convertToUTCForBackend = (date, time, period = null) => {
  if (!date || !time) return null;
  
  let timeString = time;
  
  // Convert 12-hour to 24-hour if period is provided
  if (period) {
    const [hours, minutes] = time.split(':');
    let hour24 = parseInt(hours);
    
    if (period === 'PM' && hour24 !== 12) {
      hour24 += 12;
    } else if (period === 'AM' && hour24 === 12) {
      hour24 = 0;
    }
    
    timeString = `${hour24.toString().padStart(2, '0')}:${minutes}`;
  }
  
  // Create local moment and convert to UTC
  const localDateTime = moment(`${date} ${timeString}`, 'YYYY-MM-DD HH:mm');
  
  // Return in ISO format with timezone offset
  return localDateTime.format();
};

const convertUTCToLocal = (utcTimeString) => {
  if (!utcTimeString || utcTimeString === 'send_now') {
    return {
      date: null,
      time: null,
      displayTime: null,
      displayDate: null
    };
  }
  
  // Parse UTC time and convert to local
  const localMoment = moment(utcTimeString).local();
  
  return {
    date: localMoment.format('YYYY-MM-DD'),
    time: localMoment.format('HH:mm'),
    displayTime: localMoment.format('hh:mm A'),
    displayDate: localMoment.format('YYYY-MM-DD'),
    fullDateTime: localMoment.format('YYYY-MM-DD hh:mm A')
  };
};

const validateMinimumScheduleTime = (date, time, period) => {
  if (!date || !time) return false;
  
  const utcDateTime = convertToUTCForBackend(date, time, period);
  const scheduledTime = moment(utcDateTime);
  const currentTime = moment();
  
  const timeDifference = scheduledTime.diff(currentTime, 'minutes');
  
  return timeDifference >= 60;
};

const BroadcastSetting = () => {
  const [selectedId, setSelectedId] = useState(0);
  const [selectedItems, setSelectedItems] = useState(
    Array(BroadSettingList.length).fill(false)
  );

  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedItemId, setSelectedItemId] = useState(null);
  const [isTemplateSelected, setIsTemplateSelected] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState({});
  const [numberDetails, setNumberDetails] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(false);
  const [selectedIndexSegments, setSelectedIndexSegments] = useState(false);
  const [segmentSettings, setSegmentSettings] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [response, setResponse] = useState([]);
  const [response1, setResponse1] = useState([]);

  const [startPopoverVisible, setStartPopoverVisible] = useState(false);
  const [selectedId1, setSelectedId1] = useState(false);
  const [selectedId2, setSelectedId2] = useState(false);
  const [selectedId3, setSelectedId3] = useState(false);
  const [error, setError] = useState("");
  const [broadcastId, setBroadcastId] = useState(null);
  const [campaignDetail, setCampaignDetail] = useState([]);
  const [isBroadcastViewOpen, setIsBroadcastViewOpen] = useState(false);

  const [contactsRemaining1, setContactsRemaining1] = useState(null);
  const [contactsRemaining2, setContactsRemaining2] = useState(null);

  const [contactsRemainingMerge1, setContactsRemainingMerge1] = useState(null);
  const [contactsRemainingMerge2, setContactsRemainingMerge2] = useState(null);
  const [TimePick, setTimePick] = useState(false);

  const [totalContact1, setTotalContact1] = useState(null);
  const [totalContact2, setTotalContact2] = useState(null);
  const [totalContact, setTotalContact] = useState(null);
  const [nextClicked, setNextClicked] = useState([
    true,
    false,
    false,
    false,
    false,
  ]);
  const [loading, setLoading] = useToggle(false);
  const [indexRem, setIndexRem] = useState(false);
  const [loader, setLoader] = useState(false);
  const [hours, setHours] = useState("12");
  const [minutes, setMinutes] = useState("00");
  const [periods, setPeriod] = useState("AM");

  // id --------

  let { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const campaignDetails = location?.state?.data;

  const { tabList } = useAspSelector((state) => state.Campaign);
  const { updatedInputValue } = useAspSelector((state) => state.broadcast);
  const { currentBrand, toggleToast } = useAspSelector((state) => state.app);
  const dispatch = useAspDispatch();

  const handleCloseBroadcastView = () => {
    setIsBroadcastViewOpen(true);
  };

  // useEffect(() => {
  //   const list = tabList?.filter((item) => item?.tabName === "campaignName");
  //   if (list?.length > 0) {
  //     setCampaignDetail(list[0]?.allData);
  //   }
  // }, [tabList]);

  const fetchWhatsappBusinessNumbers = (brandId) => {
    if (brandId) {
      whatsappBusinessNumbers(brandId).then((res) => {
        if (res && res.data?.wapp_business_num?.length > 0) {
          setNumberDetails(res?.data?.wapp_business_num);
        } else {
          setNumberDetails([]);
        }
      });
    } else {
      setNumberDetails([]);
    }
  };

  useEffect(() => {
    fetchWhatsappBusinessNumbers(currentBrand?.brand_id);
  }, [currentBrand]);

  // STEP 1---------------------------------------------------------------------------

  const [broadCasts, setBroadCasts] = useState({
    name: "",
    settings: {
      channel: "whatsapp",
    },
  });

  const handleCreateCampaign = (key, value) => {
    let prev = { ...broadCasts };
    prev[key] = value;
    setBroadCasts(prev);
  };

  const resetSegmentsExceptFirst = (dataName) => {
    const updatedResponse = response?.map((data, index) => {
      const updatedSegments =
        dataName === "send_now"
          ? [{ id: 1, start: 0, end: 0, delay: 0 }]
          : [{ id: 1, start: 0, end: 0, schedule_on: "" }];

      return {
        ...data,
        id: index + 1,
        segments: updatedSegments,
      };
    });

    if (broadCasts?.settings?.segment_settings) {
      const updatedSegmentSettings = broadCasts.settings.segment_settings.map(
        (segment, index) => ({
          ...segment,
          id: index + 1,
          segments:
            dataName === "send_now"
              ? [{ id: 1, start: 0, end: 0, delay: 0 }]
              : [{ id: 1, start: 0, end: 0, schedule_on: "" }],
        })
      );

      const updatedBroadcasts = {
        ...broadCasts,
        settings: {
          ...broadCasts.settings,
          segment_settings: updatedSegmentSettings,
        },
      };
      setBroadCasts(updatedBroadcasts);
    }

    setResponse1(updatedResponse);
    setResponse(updatedResponse);
    setContactsRemaining1(totalContact1);
    setContactsRemaining2(totalContact2);
    setContactsRemainingMerge1(totalContact);
  };

  const handleTimeClick = () => {
    resetSegmentsExceptFirst();

    dispatch(setSelectedTime1({ type: "clear" }));
    setTimePick(false);
    setStartPopoverVisible(false);

    if (!selectedDate || !hours || !minutes || !periods) {
      return;
    }

    // Validate minimum schedule time using UTC conversion
    const isValidTime = validateMinimumScheduleTime(selectedDate, `${hours}:${minutes}`, periods);
    
    if (!isValidTime) {
      setError(
        "Scheduled time should be at least 60 minutes ahead of the current time"
      );
      return;
    }

    // Convert to UTC for backend storage
    const utcDateTime = convertToUTCForBackend(selectedDate, `${hours}:${minutes}`, periods);
    
    if (!utcDateTime) {
      setError("Invalid date or time selected");
      return;
    }

    // Display local time to user
    const localTime = convertUTCToLocal(utcDateTime);
    setSelectedTime(localTime.displayTime);

    // Update state with UTC time for backend
    const updateSegmentsWithUTC = (prevResponse) => {
      return prevResponse?.map((data) => {
        if (data.id === 1) {
          const updatedSegments = data?.segments?.map((segment) => {
            if (segment.id === 1) {
              return {
                ...segment,
                schedule_on: utcDateTime,
              };
            }
            return segment;
          });
          return { ...data, segments: updatedSegments };
        } else {
          const updatedSegments = data?.segments?.map((segment) => {
            if (segment.id === 1) {
              return { ...segment, schedule_on: "" };
            }
            return segment;
          });
          return { ...data, segments: updatedSegments };
        }
      });
    };

    setResponse1(updateSegmentsWithUTC);
    setResponse(updateSegmentsWithUTC);

    // Update broadCasts state with UTC time
    setBroadCasts((prevState) => {
      const updatedSegmentSettings = prevState?.settings?.segment_settings?.map((data) => {
        if (data.id === 1) {
          const updatedSegments = data?.segments?.map((segment) => {
            if (segment.id === 1) {
              return { ...segment, schedule_on: utcDateTime };
            }
            return segment;
          });
          return { ...data, segments: updatedSegments };
        } else {
          const updatedSegments = data?.segments?.map((segment) => {
            if (segment.id === 1) {
              return { ...segment, schedule_on: "" };
            }
            return segment;
          });
          return { ...data, segments: updatedSegments };
        }
      });

      return {
        ...prevState,
        settings: {
          ...prevState.settings,
          segment_settings: updatedSegmentSettings,
          send_later_dt: selectedIndex === "send_later" ? utcDateTime : "send_now",
        },
      };
    });

    setError("");
  };

  const handleTime = () => {
    setTimePick(!TimePick);
  };

  const handleDateSelection = (date) => {
    setSelectedTime(null);
    const formattedDate = moment(date).format("YYYY-MM-DD");

    const startDate = campaignDetails?.starting_date_and_time;
    const endDate = campaignDetails?.ending_date_and_time;
    
    // Convert campaign dates to local for comparison
    const startDateLocal = startDate ? moment(startDate).local().format("YYYY-MM-DD") : null;
    const endDateLocal = endDate ? moment(endDate).local().format("YYYY-MM-DD") : null;

    if (startDateLocal && moment(formattedDate).isBefore(startDateLocal, "day")) {
      return;
    }
    if (endDateLocal && moment(formattedDate).isAfter(endDateLocal, "day")) {
      return;
    }

    setSelectedDate(formattedDate);

    setBroadCasts((prevState) => ({
      ...prevState,
      settings: {
        ...prevState.settings,
        send_later_dt:
          selectedIndex === "send_later"
            ? `${formattedDate} ${selectedTime}`
            : "send_now",
      },
    }));

    setStartPopoverVisible(false);
  };

  const handleClick = (id) => {
    setSelectedRole((prevSelectedRole) => {
      if (prevSelectedRole) {
        setBroadCasts((prevState) => ({
          ...prevState,
          settings: {
            ...prevState.settings,
            send_from_phone_number_id:
              prevSelectedRole.send_from_phone_number_id,
            send_from_phone_number: prevSelectedRole.send_from_phone_number,
            send_from_phone_name: prevSelectedRole.send_from_phone_name,
            country_code: prevSelectedRole.country_code,
          },
        }));
        setSelectedItemId(id);
      }
      return prevSelectedRole;
    });
  };

  const handleLabelClick = (dataName) => {
    setSelectedIndex(dataName);
    setSelectedDate(null);
    setSelectedTime(null);

    if (dataName === "send_now") {
      setError(false);
    }
    resetSegmentsExceptFirst(dataName);

    setBroadCasts((prevState) => ({
      ...prevState,
      settings: {
        ...prevState.settings,
        send_setting: dataName,
        send_later_dt:
          dataName === "send_now"
            ? "send_now"
            : `${selectedDate}${selectedTime}`,
      },
    }));
  };

  const handleLabelSegmentsClick = (dataName) => {
    setSelectedIndexSegments(dataName);
    setBroadCasts((prevState) => ({
      ...prevState,
      settings: {
        ...prevState.settings,
        segment_mode: dataName,
        segment_settings: segmentSettings,
      },
    }));
  };

  const handleNextClick = () => {
    setNextClicked((prevClicked) => {
      const newClicked = [...prevClicked];
      if (selectedId < newClicked.length - 1) {
        newClicked[selectedId + 1] = true;
      }
      return newClicked;
    });
    if (selectedId === 0) {
      setLoader(true);
    }

    if (selectedId) {
      dispatch(setUpdatedInputValue(updatedInputValue));
    }
    setContactsRemaining1(response1?.[0]?.valid_count);
    setContactsRemaining2(response1?.[1]?.valid_count);

    if (selectedId === 0) {
      let campaignPayload = { ...broadCasts };
      const broadcastIdToUse = location?.state?.item?.id || broadcastId;

      if (broadcastIdToUse) {
        campaignPayload = {
          ...campaignPayload,
          broadcast_id: broadcastIdToUse,
        };
      }

      const dateTime = campaignPayload?.settings?.send_later_dt;
      dispatch(setDateCombine(dateTime));
      broadCastCreateApi(currentBrand?.brand_id, id, campaignPayload).then(
        (createCampaignResponse) => {
          if (createCampaignResponse?.status === 200) {
            setLoader(false);
            const newBroadcastId = createCampaignResponse?.data?.id;

            setBroadcastId(newBroadcastId);
            setSelectedId((prevId) =>
              prevId < BroadSettingList.length - 1 ? prevId + 1 : prevId
            );
          } else {
            setLoader(false);
            dispatch(
              updateToggleToast([
                ...toggleToast,
                {
                  id: toggleToast?.length + 1,
                  content: createCampaignResponse?.response?.data?.error,
                  status: "Error",
                  duration: "",
                },
              ])
            );
          }
        }
      );
    } else {
      setSelectedId((prevId) =>
        prevId < BroadSettingList.length - 1 ? prevId + 1 : prevId
      );
    }

    setSelectedItems((prevItems) => {
      const newItems = [...prevItems];
      newItems[selectedId] = true;
      return newItems;
    });
  };

  useEffect(() => {
    if (location.state && location.state.item) {
      dispatch(updateGlobalLoader(true));

      const campaignId = location?.state?.item?.campaign_id;
      const broadcastId = location?.state?.item?.id;
      const brandId = currentBrand?.brand_id;
      
      broadcastSingleApi(brandId, campaignId, broadcastId)
        .then((res) => {
          if (res && res.data?.broadcast) {
            dispatch(updateGlobalLoader(false));
            const broadcastData = res?.data?.broadcast;

            setBroadCasts(broadcastData);
            setSelectedIndex(broadcastData?.settings?.send_setting);
            setSelectedIndexSegments(
              broadcastData?.settings?.segment_mode === "individual"
                ? "individual"
                : "merge"
            );

            // Convert UTC time from backend to local for display
            const { send_later_dt: sendLaterDt } = broadcastData?.settings;
            if (sendLaterDt && sendLaterDt !== "send_now") {
              const localTime = convertUTCToLocal(sendLaterDt);
              
              if (localTime.date && localTime.displayTime) {
                setSelectedTime(localTime.displayTime);
                setSelectedDate(localTime.date);
                
                // Set the time picker components for display
                const localMoment = moment(sendLaterDt).local();
                setHours(localMoment.format('hh'));
                setMinutes(localMoment.format('mm'));
                setPeriod(localMoment.format('A'));
              }
            }

            setSelectedIndexSegments(
              broadcastData?.settings?.segment_mode === "merge"
                ? "merge"
                : "individual"
            );
          } else {
            setBroadCasts([]);
          }
        })
        .finally(() => {
          dispatch(updateGlobalLoader(false));
        });
    }
  }, [location.state, currentBrand]);

  // STEP 1 COMPLETION---------------------------------------------------------------------------
  const contacts_count = response?.reduce((accumulator, currentItem) => {
    return accumulator + (currentItem?.valid_count || 0);
  }, 0);

  const remaining1 = response?.[0]?.valid_count;
  const remaining2 = response?.[1]?.valid_count;

  const template_id = selectedTemplate?.message_template_id;
  const template_name = selectedTemplate?.name;
  const template_category = selectedTemplate?.category;
  const template_subcategory_type = selectedTemplate?.subcategory_type;
  const country_code = selectedRole?.country_code;

  const createPayload = () => {
    const segmentsMapper = (part) => ({
      broadcast_part_id: part.broadcastPartId,
      segments:
        selectedIndexSegments === "merge" && part.id === 2
          ? selectedIndex === "send_now"
            ? [{ id: 1, start: 0, end: 0, delay: 0 }]
            : [
                {
                  id: 1,
                  start: 0,
                  end: 0,
                  schedule_on: "",
                },
              ]
          : [...part.segments],
    });

    const updatedSegmentSettings =
      selectedIndexSegments === "individual"
        ? response1.map(segmentsMapper)
        : response.map(segmentsMapper);

    // Prepare payment_details if the template is an ORDER_DETAIL template
    let paymentDetails = null;
    if (selectedTemplate?.subcategory_type === 'ORDER_DETAIL' && products?.length > 0) {
      paymentDetails = {
        products: products.map(product => ({
          id: product.id || '',
          name: product.name || '',
          quantity: product.quantity || 1,
          price: product.price || 0
        })),
        order_details: {
          discount: orderDetails.discount || 0,
          discount_description: orderDetails.discount_description || '',
          discount_type: orderDetails.discount_type || '',
          shipping: orderDetails.shipping || 0,
          shipping_description: orderDetails.shipping_description || '',
          tax: orderDetails.tax || 0,
          tax_description: orderDetails.tax_description || '',
          tax_type: orderDetails.tax_type || '',
          subtotal: products.reduce((sum, product) => sum + (product.price || 0) * (product.quantity || 1), 0),
          total: 0 // Will be calculated on the backend
        }
      };

      // Calculate total including tax and shipping, minus discount
      const subtotal = paymentDetails.products.reduce((sum, product) => sum + (product.price * product.quantity), 0);
      paymentDetails.order_details.subtotal = subtotal;
      paymentDetails.order_details.tax = orderDetails.tax || 0;
      paymentDetails.order_details.shipping = orderDetails.shipping || 0;
      paymentDetails.order_details.discount = orderDetails.discount || 0;
      paymentDetails.order_details.total = subtotal +
        (paymentDetails.order_details.tax || 0) +
        (paymentDetails.order_details.shipping || 0) -
        (paymentDetails.order_details.discount || 0);
    }

    // Use UTC time for backend
    const sendLaterDt = selectedIndex === "send_later" 
      ? convertToUTCForBackend(selectedDate, `${hours}:${minutes}`, periods)
      : "send_now";

    return {
      brand_id: currentBrand?.brand_id,
      broadcast_id: broadcastId,
      settings: {
        channel: "whatsapp",
        country_code: location?.state?.item
          ? broadCasts?.settings?.country_code
          : country_code,
        send_from_phone_number: location?.state?.item
          ? broadCasts?.settings?.send_from_phone_number
          : selectedRole?.send_from_phone_number,
        send_from_phone_number_id: location?.state?.item
          ? broadCasts?.settings?.send_from_phone_number_id
          : selectedRole?.send_from_phone_number_id,
        template_name: location?.state?.item
          ? broadCasts?.settings?.template_name || template_name
          : template_name,
        template_category: location?.state?.item
          ? broadCasts?.settings?.template_category || template_category
          : template_category,
        template_subcategory_type: location?.state?.item
          ? broadCasts?.settings?.template_subcategory_type ||
            template_subcategory_type
          : template_subcategory_type,
        template_id: template_id,
        send_setting: selectedIndex,
        send_later_dt: sendLaterDt,
        segment_mode: selectedIndexSegments,
        segment_settings: updatedSegmentSettings,
        contactsRemaining1:
          selectedIndexSegments === "merge"
            ? contactsRemainingMerge1
            : contacts_count,
        contactsRemaining1Individual:
          selectedIndexSegments === "individual" || contactsRemaining1
            ? contactsRemaining1
            : remaining1,
        contactsRemaining2: contactsRemaining2
          ? contactsRemaining2
          : remaining2,
        ...(paymentDetails && { payment_details: paymentDetails })
      },
    };
  };

  useEffect(() => {
    const newPayLoad = createPayload();

    dispatch(setSaveBroadcastDatas(newPayLoad));

    if (selectedId === 3) {
      draftApi(newPayLoad);
    }
  }, [
    selectedId,
    contactsRemaining1,
    contactsRemaining2,
    contactsRemainingMerge1,
  ]);

  const individualCounts = response1
    .map((item) => item.segments.map((segment) => segment?.end))
    .flat()
    .reduce((acc, value) => acc + value, 0);

  const handleCreateTask = (item) => {
    setLoading(true);
    dispatch(setCallEnabled(true));

    let updatedSegmentSettings;

    if (selectedIndexSegments === "individual") {
      updatedSegmentSettings = response1.map((part) => ({
        broadcast_part_id: part.broadcastPartId,
        segments: part.segments.map((segment) => ({ ...segment })),
      }));
    } else {
      updatedSegmentSettings = response.map((part) => ({
        broadcast_part_id: part.broadcastPartId,
        segments:
          part.id === 2 && selectedIndexSegments === "merge"
            ? []
            : part.segments.map((segment) => ({ ...segment })),
      }));
    }

    const contact3 = contacts_count - contactsRemainingMerge1;

    // Use UTC time for backend
    const sendLaterDt = selectedIndex === "send_later"
      ? convertToUTCForBackend(selectedDate, `${hours}:${minutes}`, periods)
      : "send_now";

    // Prepare payment_details if the template is an ORDER_DETAIL template
    let paymentDetails = null;
    if (selectedTemplate?.subcategory_type === 'ORDER_DETAIL' && products?.length > 0) {
      paymentDetails = {
        products: products.map(product => ({
          id: product.id || '',
          name: product.name || '',
          quantity: product.quantity || 1,
          price: product.price || 0
        })),
        order_details: {
          discount: orderDetails.discount || 0,
          discount_description: orderDetails.discount_description || '',
          discount_type: orderDetails.discount_type || '',
          shipping: orderDetails.shipping || 0,
          shipping_description: orderDetails.shipping_description || '',
          tax: orderDetails.tax || 0,
          tax_description: orderDetails.tax_description || '',
          tax_type: orderDetails.tax_type || '',
          subtotal: products.reduce((sum, product) => sum + (product.price || 0) * (product.quantity || 1), 0),
          total: 0 // Will be calculated on the backend
        }
      };

      // Calculate total including tax and shipping, minus discount
      const subtotal = paymentDetails.products.reduce((sum, product) => sum + (product.price * product.quantity), 0);
      paymentDetails.order_details.subtotal = subtotal;
      paymentDetails.order_details.tax = orderDetails.tax || 0;
      paymentDetails.order_details.shipping = orderDetails.shipping || 0;
      paymentDetails.order_details.discount = orderDetails.discount || 0;
      paymentDetails.order_details.total = subtotal +
        (paymentDetails.order_details.tax || 0) +
        (paymentDetails.order_details.shipping || 0) -
        (paymentDetails.order_details.discount || 0);
    }

    const payLoad = {
      brand_id: currentBrand?.brand_id,
      settings: {
        channel: "whatsapp",
        country_code: location?.state?.item
          ? broadCasts?.settings?.country_code
          : country_code,
        send_from_phone_number: location?.state?.item
          ? broadCasts?.settings?.send_from_phone_number
          : selectedRole?.send_from_phone_number,
        send_from_phone_number_id: location?.state?.item
          ? broadCasts?.settings?.send_from_phone_number_id
          : selectedRole?.send_from_phone_number_id,
        template_name: location?.state?.item
          ? broadCasts?.settings?.template_name || template_name
          : template_name,
        template_category: location?.state?.item
          ? broadCasts?.settings?.template_category || template_category
          : template_category,
        template_subcategory_type: location?.state?.item
          ? broadCasts?.settings?.template_subcategory_type ||
            template_subcategory_type
          : template_subcategory_type,
        template_id: template_id,
        send_setting: selectedIndex,
        send_later_dt: sendLaterDt,
        segment_mode: selectedIndexSegments,
        segment_settings: updatedSegmentSettings,
        contacts_count:
          selectedIndexSegments === "merge" ? contact3 : individualCounts,
        contactsRemaining1:
          selectedIndexSegments === "merge"
            ? contactsRemainingMerge1
            : contactsRemaining1,
        contactsRemaining1Individual:
          selectedIndexSegments === "individual"
            ? contactsRemaining1
            : remaining1,
        contactsRemaining2: contactsRemaining2 ? contactsRemaining2 : 0,
        ...(paymentDetails && { payment_details: paymentDetails })
      },
    };

    if (broadcastId && contacts_count) {
      dispatch(setUpdatedInputValue({}));
      setContactsRemaining1(null);
      setContactsRemaining2(null);
      dispatch(setDelayValue({}));
      dispatch(setDelayValue1(null));
    }

    createActivateApi(broadcastId, payLoad).then((createCampaignResponse) => {
      if (createCampaignResponse?.status === 200) {
        setLoading(false);

        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: "Broadcast activated successfully",
              status: "Success",
              duration: "",
            },
          ])
        );
        // navigate(`/user/campaign/time_specified/${id}`, { state: { item } });
        navigate(`/user/campaign/view/${id}/execution`, {
          state: { item, data: campaignDetails },
        });
      } else {
        setLoading(false);

        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content:
                createCampaignResponse?.response?.data?.error ||
                "Broadcast activation failed",
              status: "Error",
              duration: "",
            },
          ])
        );
      }
    });
  };

  const handleDraft = (item) => {
    dispatch(setUpdatedInputValue({}));
    dispatch(setDelayValue1(null));
    dispatch(setIndividualError({}));
    dispatch(setCallEnabled(true));

    const payLoad = createPayload();

    if (indexRem && broadcastId) {
      setContactsRemaining1(contactsRemaining1);
      setContactsRemaining2(contactsRemaining2);
    }
    draftApi(payLoad).then((createCampaignResponse) => {
      if (createCampaignResponse?.status === 200) {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content: "Broadcast saved successfully",
              status: "Success",
              duration: "",
            },
          ])
        );
      } else {
        dispatch(
          updateToggleToast([
            ...toggleToast,
            {
              id: toggleToast?.length + 1,
              content:
                createCampaignResponse?.response?.data?.error ||
                "Unable to save Broadcast  ",

              status: "Error",
              duration: "",
            },
          ])
        );
      }
    });
    navigate(`/user/campaign/view/${id}/execution`, {
      state: { item, data: campaignDetails },
    });

    // navigate(`/user/campaign/time_specified/${id}`, { state: { item } });
  };

  const templateId = broadCasts?.settings?.template_id;

  const fetchSingleTemplateLists = (brandId, templateId) => {
    if (brandId) {
      templateList(brandId, templateId)
        .then((res) => {
          if (res?.status === 200) {
            setSelectedTemplate(res?.data?.wapp_template);
          }
        })
        .finally(() => {});
    } else {
      setSelectedTemplate([]);
    }
  };

  useEffect(() => {
    if (templateId) {
      fetchSingleTemplateLists(currentBrand?.brand_id, templateId);
      if (broadCasts && location?.state?.item) {
        setSelectedId3(true);
      }
    }
  }, [currentBrand, templateId]);

  useEffect(() => {
    if (selectedId === 0 && !indexRem) {
      dispatch(clearIndividualErrors());
    }
  }, []);

  const handleIndex = (index) => {
    if (index > selectedId && !nextClicked[selectedId + 1]) {
      return;
    }
    if (selectedId === 2) {
      setIndexRem(true);
    }
    if (index < selectedId) {
      setSelectedId(index);
      return;
    }
    if (
      selectedId === 0 &&
      (!broadCasts?.name?.trim() ||
        Object.keys(broadCasts.settings).length < 6 ||
        broadCasts.settings.send_later_dt.includes("null") ||
        broadCasts.settings.send_later_dt.includes("00:00:00"))
    ) {
      return;
    }
    if (selectedId === 1 && !selectedId1) {
      return;
    }
    if (selectedId === 2 && !selectedId2) {
      return;
    }
    if (selectedId === 3 && !selectedId3 && !location?.state?.item) {
      return;
    }
    dispatch(setUpdatedInputValue(updatedInputValue));
    setSelectedId(index);
    setNextClicked((prevClicked) => {
      const newClicked = [...prevClicked];
      for (let i = index + 1; i < newClicked.length; i++) {
        newClicked[i] = false;
      }
      return newClicked;
    });
  };

  const notification = useContext(NotificationContext);

    // Order details state
    const [products, setProducts] = useState([
      { id: '', name: '', quantity: 1, price: 0, image_url: '' }
    ]);
    const [availableProducts, setAvailableProducts] = useState([]);

    const [orderDetails, setOrderDetails] = useState({
      discount: 0,
      discount_type: 'percent',
      discount_description: '',
      shipping: 0,
      shipping_description: '',
      tax: 0,
      tax_type: 'tax_exclusive',
      tax_description: '',
      goods_type: 'digital-goods'
    });

    // Handle product field changes
    const handleProductChange = (index, field, value) => {
      const updatedProducts = [...products];

      // If updating quantity, ensure it's a valid number between 1 and 100
      if (field === 'quantity') {
        const numValue = parseInt(value, 10) || 1;
        updatedProducts[index] = {
          ...updatedProducts[index],
          [field]: Math.max(1, Math.min(100, numValue))
        };
      } else {
        updatedProducts[index] = { ...updatedProducts[index], [field]: value };
      }

      setProducts(updatedProducts);
    };

    // Handle order detail changes
    const handleOrderDetailChange = (field, value) => {
      setOrderDetails(prev => ({
        ...prev,
        [field]: value
      }));
    };

    // Handle product removal
    const handleRemoveProduct = (index) => {
      if (products.length > 1) {
        const updatedProducts = [...products];
        updatedProducts.splice(index, 1);
        setProducts(updatedProducts);
      }
    };

    // Handle adding a new product
    const handleAddProduct = () => {
      setProducts([...products, {
        id: '',
        name: '',
        quantity: 1,
        price: 0
      }]);
    };

    // Handle product selection from dropdown
    const handleProductSelect = (index, productId) => {

      if (productId) {
        // Check if this product is already selected in another row
        const isProductAlreadySelected = products.some((product, i) =>
          i !== index && product.id == productId
        );

        if (isProductAlreadySelected) {
          // Reset the current selection
          const updatedProducts = [...products];
          updatedProducts[index] = {
            ...updatedProducts[index],
            id: '',
            name: '',
            price: 0
          };
          setProducts(updatedProducts);

          // Show error message or alert
          showErrorToast(notification, "Product already selected, select another product");
          return;
        }

        const selectedProduct = availableProducts.find(p => {
          return p.id == productId; // Use loose equality to handle string/number mismatches
        });

        if (!selectedProduct) {
          console.error('Product not found. Available product IDs:', availableProducts.map(p => ({ id: p.id, type: typeof p.id })));
        }

        if (selectedProduct) {
          const updatedProducts = [...products];
          updatedProducts[index] = {
            ...updatedProducts[index],
            id: selectedProduct.id,
            name: selectedProduct.name || '',
            price: selectedProduct.price || 0,
            image_url: selectedProduct.image_url || '',
            quantity: updatedProducts[index]?.quantity || 1 // Keep existing quantity or default to 1
          };

          setProducts(updatedProducts);
        }
      } else {
        // If productId is empty, reset the product
        const updatedProducts = [...products];
        updatedProducts[index] = {
          id: '',
          name: '',
          price: 0,
          quantity: 1
        };
        setProducts(updatedProducts);
      }
    };

    // Fetch products when component mounts
    useEffect(() => {
      const fetchProducts = async () => {
        try {
          const response = await getProducts(currentBrand?.brand_id);
          if (response?.status == 200) {
            setAvailableProducts(response?.data?.products);
          }
        } catch (error) {
          console.error('Error fetching products:', error);
        }
      };

      if (currentBrand?.brand_id) {
        fetchProducts();
      }
    }, [currentBrand?.brand_id]);

    // Log products state whenever it changes
    useEffect(() => {
    }, [products]);

  return (
    <div className="w-100">
      <CampaignHeader campaignDetails={campaignDetails} />
      <div className="w-98 m-10 ">
        <div className="BroadcastSetting-wrapper flex-row align-center w-100 space-between">
          <div className="flex-row align-center">
            {BroadSettingList?.map((data, index) => (
              <div
                className=" pointer flex-row align-center"
                key={data.id}
                onClick={() => handleIndex(index)}
              >
                <div className="flex-row align-center">
                  <img
                    src={
                      selectedItems[index] ||
                      index === selectedId ||
                      index === selectedId - 1
                        ? ICONS?.BroadcastRoundGreenTick
                        : data?.icon
                    }
                    alt="img"
                  />

                  <p
                    style={{
                      color:
                        selectedItems[index] ||
                        index === selectedId ||
                        index === selectedId - 1
                          ? "var(--new-primary)"
                          : "var(--font-400)",
                    }}
                  >
                    {data?.name}
                  </p>
                </div>

                {index !== 4 && (
                  <img
                    src={
                      selectedItems[index] ||
                      index === selectedId ||
                      index === selectedId - 1
                        ? ICONS?.chevronGreen
                        : ICONS?.chevronRightIcon
                    }
                    alt="img"
                    className="pl-10 pr-10 chevronImage"
                  />
                )}
              </div>
            ))}
          </div>

          <div className="flex-row align-center flex-end">
            {selectedId !== 0 && (
              <div className="button pointer">
                <ConfigProvider
                  theme={{
                    components: {
                      Button: {
                        defaultBg: "#fff",
                        defaultColor: "#fff",
                        defaultHoverBg: "#fff",
                        defaultHoverColor: "#fff",
                        defaultHoverBorderColor: "#fff",
                        defaultActiveColor: "#fff",
                        defaultActiveBg: "#fff",
                        defaultActiveBorderColor: "#fff",
                        defaultBorderColor: "#fff",
                        boxShadow: "none",
                        defaultShadow: "none",
                        defaultHoverShadow: "none",
                        defaultActiveShadow: "none",
                      },
                    },
                  }}
                >
                  <Button
                    className="Draft-btn"
                    size={"small"}
                    onClick={() => handleDraft(campaignDetails)}
                  >
                    <Typography.Text className="text-xs text-[var(--font-600)] font-medium">
                    Draft
                    </Typography.Text>
                  </Button>
                </ConfigProvider>
              </div>
            )}

            {selectedId < BroadSettingList?.length - 1 ? (
              <button
                onClick={handleNextClick}
                loading={loader}
                disabled={
                  loader ||
                  error ||
                  (selectedId === 0 &&
                    (!broadCasts?.name?.trim() ||
                      Object.keys(broadCasts?.settings)?.length < 6 ||
                      broadCasts?.settings?.send_later_dt?.includes("null") ||
                      !broadCasts?.settings?.send_from_phone_number_id)) ||
                  (selectedId === 1 && selectedId1 === false) ||
                  (selectedId === 2 && selectedId2 === false) ||
                  (selectedId === 3 &&
                    selectedId3 === false &&
                    !location?.state?.item)
                }
                style={{
                  backgroundColor:
                    error ||
                    (selectedId === 0 &&
                      (!broadCasts?.name?.trim() ||
                        Object.keys(broadCasts?.settings)?.length < 6 ||
                        broadCasts?.settings.send_later_dt?.includes("null") ||
                        !broadCasts?.settings?.send_from_phone_number_id)) ||
                    (selectedId === 1 && selectedId1 === false) ||
                    (selectedId === 2 && selectedId2 === false) ||
                    (selectedId === 3 && selectedId3 === false)
                      ? "var(--lightGrey)"
                      : "var(--new-primary)",
                  color:
                    error ||
                    (selectedId === 0 &&
                      (!broadCasts?.name?.trim() ||
                        Object.keys(broadCasts?.settings)?.length < 6 ||
                        broadCasts?.settings.send_later_dt?.includes("null") ||
                        !broadCasts?.settings?.send_from_phone_number_id)) ||
                    (selectedId === 1 && selectedId1 === false) ||
                    (selectedId === 2 && selectedId2 === false) ||
                    (selectedId === 3 && selectedId3 === false)
                      ? "var(--darkgrey)"
                      : "white",
                  padding: "5px 5px 5px 10px",
                  border: "none",
                  borderRadius: "5px",
                  cursor:
                    (selectedId === 0 &&
                      (!broadCasts?.name?.trim() ||
                        Object.keys(broadCasts?.settings)?.length < 6 ||
                        broadCasts?.settings?.send_later_dt?.includes(
                          "null"
                        ))) ||
                    (selectedId === 1 && selectedId1 === false) ||
                    (selectedId === 2 && selectedId2 === false) ||
                    (selectedId === 3 && selectedId3 === false)
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {loader ? (
                  <div
                    style={{ width: "40px", padding: "0 5px" }}
                    className="flex-row align-center justify-center"
                  >
                    <Loader Width={15} Height={15} loaderBg="white" />
                  </div>
                ) : (
                  <span className="next flex-row align-center">
                    Next
                    <img
                      src={ICONS?.chevronRightIconWhite}
                      alt="chevronRightIconWhite"
                    />
                  </span>
                )}
              </button>
            ) : (
              // <Button
              //   label={"Activate _ siva"}
              //   size={"medium"}
              //   onClick={() => handleCreateTask(campaignDetails)}
              //     loading={loading}
              //     disabled={true}
              // />
              <ConfigProvider
                theme={{
                  components: {
                    Button: {
                      defaultBg: "#05805C",
                      defaultColor: "#fff",
                      defaultHoverBg: "#fff",
                      defaultHoverColor: "#05805C",
                      defaultHoverBorderColor: "#05805C",
                      defaultActiveColor: "#05805C",
                      defaultActiveBg: "#fff",
                      defaultActiveBorderColor: "#05805C",
                      defaultBorderColor: "#05805C",
                    },
                  },
                }}
              >
                <Button
                  disabled={loading}
                  loading={loading}
                  onClick={() => handleCreateTask(campaignDetails)}
                  className="px-3 py-[.85rem]"
                  size="small"
                >
                  Activate
                </Button>
              </ConfigProvider>
            )}
          </div>
        </div>
      </div>

      <div
        className="Broadcast-main w-70 align-center flex-row"
        style={{
          background: "var(--Primary-White, #fff)",
          boxShadow: " 0px 1.5px 2px 0px rgba(16, 24, 40, 0.1)",
          margin: "auto",
          padding: "20px 20px 20px 20px",
        }}
      >
        {selectedId === 0 && (
          <SettingBroad
            handleCreateCampaign={handleCreateCampaign}
            handleClick={handleClick}
            setSelectedRole={setSelectedRole}
            selectedRole={selectedRole}
            selectedItemId={selectedItemId}
            numberDetails={numberDetails}
            handleLabelClick={handleLabelClick}
            setSelectedIndex={setSelectedIndex}
            selectedIndex={selectedIndex}
            handleDateSelection={handleDateSelection}
            selectedDate={selectedDate}
            selectedTime={selectedTime}
            broadCasts={broadCasts}
            broadcastId={broadcastId}
            TimePick={TimePick}
            setTimePick={setTimePick}
            startPopoverVisible={startPopoverVisible}
            setStartPopoverVisible={setStartPopoverVisible}
            hours={hours}
            minutes={minutes}
            periods={periods}
            handleTimeClick={handleTimeClick}
            setHours={setHours}
            setMinutes={setMinutes}
            setPeriod={setPeriod}
            campaignDetail={campaignDetails}
            error={error}
            handleTime={handleTime}
          />
        )}

        {selectedId == 1 && (
          <Define_Audience
            response={response}
            setResponse={setResponse}
            response1={response1}
            setResponse1={setResponse1}
            selectedIndex={selectedIndex}
            broadCasts={broadCasts}
            broadcastId={broadcastId}
            setSelectedId1={setSelectedId1}
            selectedId1={selectedId1}
            setIndexRem={setIndexRem}
            indexRem={indexRem}
            setSelectedIndexSegments={setSelectedIndexSegments}
            setBroadCasts={setBroadCasts}
          />
        )}

        {selectedId === 2 && (
          <BroadcastSegments
            handleLabelSegmentsClick={handleLabelSegmentsClick}
            selectedIndexSegments={selectedIndexSegments}
            setSelectedIndexSegments={setSelectedIndexSegments}
            numberDetails={numberDetails}
            segmentSettings={segmentSettings}
            setSegmentSettings={setSegmentSettings}
            selectedIndex={selectedIndex}
            response={response}
            setResponse={setResponse}
            response1={response1}
            setResponse1={setResponse1}
            broadCasts={broadCasts}
            setSelectedId2={setSelectedId2}
            indexRem={indexRem}
            setIndexRem={setIndexRem}
            contactsRemaining1={contactsRemaining1}
            contactsRemaining2={contactsRemaining2}
            contactsRemainingMerge1={contactsRemainingMerge1}
            contactsRemainingMerge2={contactsRemainingMerge2}
            setContactsRemainingMerge1={setContactsRemainingMerge1}
            setContactsRemainingMerge2={setContactsRemainingMerge2}
            setContactsRemaining1={setContactsRemaining1}
            setContactsRemaining2={setContactsRemaining2}
            selectedId2={selectedId2}
            totalContact1={totalContact1}
            setTotalContact1={setTotalContact1}
            totalContact2={totalContact2}
            setTotalContact2={setTotalContact2}
            totalContact={totalContact}
            setTotalContact={setTotalContact}
          />
        )}

        {selectedId === 3 &&
          (location?.state?.item &&
          !isBroadcastViewOpen &&
          broadCasts?.settings?.template_name !== null ? (
            <BroadcastMessageView
              segment={broadCasts}
              broadcasts={broadCasts}
              onClose={handleCloseBroadcastView}
              setSelectedId3={setSelectedId3}
              selectedTemplate={selectedTemplate}
              setSelectedTemplate={setSelectedTemplate}
              data
              products={products}
              availableProducts={availableProducts}
              orderDetails={orderDetails}
              onProductChange={handleProductChange}
              onProductSelect={handleProductSelect}
              onOrderDetailChange={handleOrderDetailChange}
              onRemoveProduct={handleRemoveProduct}
              onAddProduct={handleAddProduct}
            />
          ) : (
            <BroadcastMessage
              isTemplateSelected={isTemplateSelected}
              setIsTemplateSelected={setIsTemplateSelected}
              selectedTemplate={selectedTemplate}
              setSelectedTemplate={setSelectedTemplate}
              selectedIndex={selectedIndex}
              setSelectedIndex={setSelectedIndex}
              broadCasts={broadCasts}
              selectedRole={selectedRole}
              setSelectedId3={setSelectedId3}
              response={response}
              products={products}
              availableProducts={availableProducts}
              orderDetails={orderDetails}
              onProductChange={handleProductChange}
              onProductSelect={handleProductSelect}
              onOrderDetailChange={handleOrderDetailChange}
              onRemoveProduct={handleRemoveProduct}
              onAddProduct={handleAddProduct}
            />
          ))}

        {selectedId === 4 && (
          <BroadcastReview
            broadCasts={broadCasts}
            selectedTemplate={selectedTemplate}
            segmentSettings={segmentSettings}
            selectedRole={selectedRole}
            response={response}
            response1={response1}
            selectedIndexSegments={selectedIndexSegments}
            products={products}
            orderDetails={orderDetails}
          />
        )}
      </div>
    </div>
  );
};

export default BroadcastSetting;
